export default __webpack_public_path__ + "/images/floppy_disk.png";